import type { AuthUser } from './types';

export function getRoleKey(user: Pick<AuthUser, 'roleName' | 'userType'>): string {
  return user.roleName?.toLowerCase() || user.userType?.toLowerCase() || '';
}

/** True only for the Admin role — not SuperAdmin, SuperUser, SME, or Client. */
export function isAdminUser(user: Pick<AuthUser, 'roleName' | 'userType'> | null | undefined): boolean {
  if (!user) return false;
  return getRoleKey(user) === 'admin';
}

/** True for SuperAdmin. */
export function isSuperAdminUser(
  user: Pick<AuthUser, 'roleName' | 'userType'> | null | undefined
): boolean {
  if (!user) return false;
  return getRoleKey(user) === 'superadmin';
}

/** Roles that review capability + project-setup requests. */
export function isApproverUser(
  user: Pick<AuthUser, 'roleName' | 'userType'> | null | undefined
): boolean {
  return isAdminUser(user) || isSuperAdminUser(user);
}

/** Client portal roles that use project-scoped chat/report sidebar badges. */
export function isClientPortalUser(
  user: Pick<AuthUser, 'roleName' | 'userType'> | null | undefined
): boolean {
  if (!user) return false;
  const key = getRoleKey(user);
  return key === 'client' || key === 'superuser';
}
